import React from 'react'
import { MobileNavBar } from './MobileNavBar'
import { Link } from 'react-router-dom'
import { Logo } from '../Logo'
import { ActionWidget } from './ActionWidget'
import GeneralSearch from './GeneralSearch'
import { SearchViaAiButton } from './SearchViaAiButton'
import { CartWidget } from './CartWidget'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { useToggle } from 'react-use'

export const MobileHeader = () => {
  const [showNavBar, setShowNavBar] = useToggle(false)
  const [showSearch, setShowSearch] = useToggle(false)

  return (
    <React.Fragment>
      <header className="bg-primary d-block d-lg-none py-2">
        <section className="p-2">
          <div className="d-flex justify-content-between align-items-center">
            <ShowIf condition={!showSearch}>
              <div className="">
                <ActionWidget icon="bars" onClick={() => setShowNavBar(true)} />
              </div>

              <div className="">
                <Link to="/">
                  <Logo type="white" />
                </Link>
              </div>

              <HorizontalStack gap={2}>
                <SearchViaAiButton />
                <ActionWidget icon="search" onClick={() => setShowSearch(true)} />
                <CartWidget />
              </HorizontalStack>
            </ShowIf>
          </div>

          <ShowIf condition={showSearch}>
            <HorizontalStack gap={2}>
              <div className="flex-grow-1">
                <GeneralSearch onBack={setShowSearch} />
              </div>
              <SearchViaAiButton />
            </HorizontalStack>
          </ShowIf>
        </section>
      </header>
      <MobileNavBar show={showNavBar} onShow={setShowNavBar} />
    </React.Fragment>
  )
}
